import React, { PropTypes } from 'react';
import { fadein } from '../decorators';
import classnames from 'classnames';

const DeckItem = ({ deckId, description, filter, id, name, onSelect, targetLanguage, visible }) => {
    if (filter) {
        let partsToSearch = [name, description, targetLanguage];
        let rxFilters = filter.trim().split(/\s+/).map(filterItem => new RegExp(filterItem, 'i'));
        visible = visible && rxFilters.every(rxFilter => partsToSearch.some(string => rxFilter.test(string)));
    }

    let classes = classnames({
        'deck-item': true,
        'selected': id === deckId,
        visible
    });

    return (<div className={classes} onClick={ () => onSelect(id) }>
        <h2>{ name || '?????' }</h2>
        <h3>{ targetLanguage || '???' }</h3>
        { description ? <p>{ description }</p> : null }
    </div>);
};

DeckItem.propTypes = {
    cardCount: PropTypes.number,
    created: PropTypes.number,
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    lastUpdated: PropTypes.number,
    name: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    ownerHandle: PropTypes.string,
    targetLanguage: PropTypes.string,
    visible: PropTypes.bool.isRequired
};

export default fadein(DeckItem);


// WEBPACK FOOTER //
// ./src/components/decklist/deckitem.js